import type { ImmutableArray } from 'seamless-immutable';
import {
  differenceInMinutes,
  differenceInSeconds,
  duration,
  format,
} from '@querodelivery/qd-date-helper';
import { Text } from '@querodelivery/uni-react';
import { useAppDispatch } from '@/_store/hooks';
import styles from './delivery-activity-box.module.scss';
import type { IEvent } from '@/Interfaces/Data';
import { showEventModal } from '@/_store/modules/layout';
import { normalizeStatus } from '@/Utils/FnUtils';

interface DeliveryActivityBoxProps {
  events?: ImmutableArray<IEvent>;
}

export const DeliveryActivityBox = ({ events }: DeliveryActivityBoxProps) => {
  const dispatch = useAppDispatch();

  const hasEvents = events && events.length > 0;

  return (
    <div className={styles.container}>
      <Text
        fontSize="md"
        lineHeight="lg"
        fontWeight="semibold"
        tone="supporting"
      >
        Atividade da entrega
      </Text>

      {hasEvents && (
        <div className={styles.deliveryInformationContainer}>
          <div className={styles.deliveryInformation}>
            {events.map((event, index) => {
              const getDuration = () => {
                if (index === 0) {
                  return '';
                }

                const durationUntilLast = duration(
                  events[index - 1].createdAt,
                  events[index].createdAt,
                );

                if (durationUntilLast !== 'agr') {
                  return `+${durationUntilLast}`;
                }

                const diffMinutes = differenceInMinutes(
                  events[index].createdAt,
                  events[index - 1].createdAt,
                );

                const diffSeconds = differenceInSeconds(
                  events[index].createdAt,
                  events[index - 1].createdAt,
                );

                if (!diffMinutes && !diffSeconds) {
                  return '';
                }

                return `+${diffMinutes ? `${diffMinutes}min ` : ''}${
                  diffSeconds ? `${diffSeconds}s` : ''
                }`;
              };
              return (
                <div key={index}>
                  <a
                    type="button"
                    onClick={() => {
                      dispatch(showEventModal(event));
                    }}
                  >
                    {normalizeStatus(event.evento)}
                  </a>
                  <span title="Tempo desde o último evento">
                    {format(event.createdAt, 'dd/MM/yyyy HH:mm:ss')}{' '}
                    {getDuration()}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
